import React from 'react';
import { bool, object, string } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import {
    FiverrChoiceBadge,
    VettedProBadge,
    SellerLevelOneBadge,
    SellerLevelTwoBadge,
    TopRatedBadge,
    BuyItAgainBadge,
} from '@fiverr-private/badges';
import { GIG_FEATURE_BADGE_TYPES, SELLER_LEVELS } from '../../../../GigCardListings/utils/gigBadges/constants';
import { isInExperimentGroup } from '../../../../GigCardListings/ListingsTransformer/abTestsTransformer';
import { ALLOCATIONS, EXPERIMENTS } from '../../../../constants/experiments';

const MAP_TYPE_TO_BADGE = {
    [GIG_FEATURE_BADGE_TYPES.PRO]: VettedProBadge,
    [GIG_FEATURE_BADGE_TYPES.FIVERR_CHOICE]: FiverrChoiceBadge,
    [GIG_FEATURE_BADGE_TYPES.BUY_IT_AGAIN]: BuyItAgainBadge,
};

const MAP_SELLER_LEVEL_TO_BADGE = {
    [SELLER_LEVELS.TOP_RATED_SELLER]: TopRatedBadge,
    [SELLER_LEVELS.LEVEL_ONE_SELLER]: SellerLevelOneBadge,
    [SELLER_LEVELS.LEVEL_TWO_SELLER]: SellerLevelTwoBadge,
};

const Badge = ({ type, level, excludeTooltip, shouldShowGigTypeBadge = true, isAgency = false }) => {
    const { isTouch, abTests } = getContext();
    const hideTooltip = excludeTooltip || isTouch;
    const showTooltip = !hideTooltip;

    const showSellerOverlay = isInExperimentGroup(EXPERIMENTS.HAWKS_OVERLAY_BADGES, [ALLOCATIONS.TEST_B], abTests);
    try {
        const TypeBadge = MAP_TYPE_TO_BADGE[type];
        const isProOrFiverrChoice = [GIG_FEATURE_BADGE_TYPES.PRO, GIG_FEATURE_BADGE_TYPES.FIVERR_CHOICE].includes(type);
        const showOverlayInsteadOfBadge = showSellerOverlay && isProOrFiverrChoice;
        const shouldShowTypeBadge = shouldShowGigTypeBadge && !showOverlayInsteadOfBadge && TypeBadge;

        if (shouldShowTypeBadge) {
            return (
                <span style={{ flexShrink: 0 }}>
                    <TypeBadge showTooltip={showTooltip} appendTooltipToBody isAgency={isAgency} />
                </span>
            );
        }

        const LevelBadge = MAP_SELLER_LEVEL_TO_BADGE[level];
        if (LevelBadge) {
            return (
                <span style={{ flexShrink: 0 }}>
                    <LevelBadge showTooltip={showTooltip} appendTooltipToBody />
                </span>
            );
        }

        return null;
    } catch (e) {
        return null;
    }
};

Badge.propTypes = {
    type: object,
    level: string,
    excludeTooltip: bool,
    shouldShowGigTypeBadge: bool,
    isAgency: bool,
};

export default Badge;
